import queryString from 'query-string';
import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';

/* Customer Information Downloads */

export const fetchCustomerDownloadTypes = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/downloadTypes';
    return callApi(endpoint);
};

export const fetchCustomerDownloadTopics = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/downloadTypes';
    return callApi(endpoint);
};

export const fetchCustomerDownloads = (
    typeName: string,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify(pageable, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/downloads/download/${typeName}${query}`;

    return callApi(endpoint);
};

/* Customer Bill Downloads */

export const fetchCustomerBillsInfo = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/billsInformation';

    return callApi(endpoint);
};

export interface FetchCustomerBillsParams {
    year?: string;
    month?: string;
}

export const fetchCustomerBills = (
    params: FetchCustomerBillsParams,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...params, ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/bills${query}`;

    return callApi(endpoint);
};

/* Commission Bill Downloads */

export const fetchCustomerCommissionBillsInfo = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/resource/customer/' + customerId + '/commissionBillsInformation';

    return callApi(endpoint);
};

export interface FetchCustomerCommissionBillsParams {
    year?: string;
}

export const fetchCustomerCommissionBills = (
    params: FetchCustomerCommissionBillsParams,
    pageable: PageableQueryParams = {}
): Promise<CallApiResult> => {
    let query = queryString.stringify({ ...params, ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    const customerId = getCustomerId();
    const endpoint = `/api/resource/customer/${customerId}/commissionBills${query}`;

    return callApi(endpoint);
};
